import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import classNames from 'classnames/bind';
import { dispatchPage } from '@/src/mobile/components/Link';
import { userIsLogin, userLogin } from '@src/public/utils/app';
import styles from './index.css';

const cx = classNames.bind(styles);

const Item = ({ content }) => {
    const { title, url, reg, iconClass, needLogin } = content;
    const { pathname } = window.location;
    const isCurrent = reg.test(pathname);

    const handleClick = () => {
        // 未登录的情况下先登录
        if (needLogin && !userIsLogin()) {
            userLogin();

            return;
        }

        // 已登录的情况
        // 非本页面的情况下才进行跳转
        if (!isCurrent) {
            dispatchPage({ to: url });
        }
    };

    return (
        <div className={cx('wrap', isCurrent ? 'current' : '')} onClick={handleClick}>
            <div className={cx('icon', iconClass)} />
            <div className={styles.title}>{title}</div>
        </div>
    );
};

Item.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Item);
